import React, { ChangeEvent } from 'react';
import SearchInput from '../../../Common/SearchInput';
import { WEBINAR_SEARCH_PROPS } from '../../Utils/types';

const WebinarSearch = ({
  products,
  onProductChange,
  setSearchText,
  searchText,
  showProductDropdown,
}: WEBINAR_SEARCH_PROPS): JSX.Element => {
  const clearSearch = () => {
    setSearchText('');
  };

  const onTextChange = (e: ChangeEvent<HTMLInputElement>) => {
    setSearchText(e.target.value);
  };

  return (
    <div
      className="rounded-lg p-4 flex gap-4 sticky top-0 sm:p-2"
      style={{ background: 'rgba(243, 246, 249, 0.15)' }}
    >
      <select
        className={`px-4 bg-white border rounded-md text-base text-center sm:text-s-12 sm:px-2 ${
          showProductDropdown ? '' : 'hidden'
        }`}
        onChange={(e) => onProductChange(e)}
      >
        <option value="">All</option>
        {products?.map((product) => (
          <option
            data-label={product.title}
            value={product.id}
            key={product.id}
          >
            {product.title}
          </option>
        ))}
      </select>

      <SearchInput
        parantDivClass="w-full bg-white sm:py-1"
        className="w-full"
        placeholder="Search"
        isComponentVisible={true}
        closeIconCB={clearSearch}
        searchText={searchText}
        onTextChanged={onTextChange}
      />
    </div>
  );
};

export { WebinarSearch };
